import styled from 'styled-components'
import clsx from 'clsx'
const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  &.hero {
    background: linear-gradient(180deg, #5DB5AA, #003d37 75%);
  }

  &.search {
    background-image: linear-gradient(to bottom, #5DB5AA, #003d37 80%);
  }

  &.default {
    background-image: linear-gradient(to bottom, #5DB5AA, #003d37 80%);
  }
`

interface Props {
  className?: string
  background: App.SiteTakeoverBackground
}

function TourAsiaCampaignTakeoverBackground(props: Props) {
  const { className, background } = props

  return <Container className={clsx(className, background)} />
}

export default TourAsiaCampaignTakeoverBackground
